<template>
	<div class="content">

	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		},
		created() {
			this.$store.state.authentication.loggedIn = false
			this.$store.state.authentication.authToken = null
			this.$store.state.authentication.name = null
			this.$store.state.authentication.hash_id = null
			this.$router.push("/");
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue